// @ts-nocheck
import { AnyAction, Dispatch } from 'redux';
import {
  clearBasketLocalStorage,
  customMap,
  setSelectedCityInStorage,
} from '../../../../utils';
import {
  handleEcommerceData,
  handleEnhancedEcommerceData,
} from '../../../../utils/enhanceEcommerce';
import { handleYouLeadPurchase } from '../../../../utils/youLeadEvents';
import { isFirefox, isSafari } from 'react-device-detect';
import {
  mealExchangeChangeEditModalClickedArea,
  mealExchangeSelectProgram,
  resetPreviouslySelectedDietDetails,
} from '../../../../redux/actions/orderFormActions';
import {
  resetBasket,
  storeBasket,
  storePromoCode,
} from '../../../../redux/actions/basketActions';
import {
  chooseExistingAddress,
  selectCityOrZipcode,
} from '../../../../redux/actions/summaryActions';
import { DeliveryMethodEnum } from '../../../../features/pickupPoint/types/deliveryMethod.enum';
import { compressToURL } from '@eonasdan/lz-string';
import { profileOrder } from '../../../../features/orderForm/stepSummary/utils/profileOrder.util';
import { guestOrder } from '../../../../features/orderForm/stepSummary/utils/guestOrder.util';
import { generateCalculation } from './generateCalculation.util';
import { generateSelectedFees } from './generateSelectedFees.util';
import { NewProfileAddressT } from '../../../../features/orderForm/stepSummary/types/stepSummary.type';
import { generateSimpleOrders } from './generateOrderData.util';
import {
  placeLoggedInOrder,
  placeLoggedInOrderPdf,
  placeOpenOrder,
  placeOpenOrderPdf,
} from '../../../../redux/actions/profileActions';
import { getSummaryReducer } from '../../../../redux/selectors/summaryReducer.selectors';
import { getBasketReducer } from '../../../../redux/selectors/orderFormSelector';
import { getProfileDetails } from '../../../../redux/selectors/profileSelector';
import {
  getAdditionalFees,
  getFinalSumAfterDiscountAndDeliveryFee,
  getLoyaltyPointsForRegistration,
  getPdfFile,
} from '../../../../redux/selectors/basketSelector';
import { getServerConfig } from '../../../../features/general/generalSlice';
import { hashString } from '../../../../utils/hashString.util';

export const displayOrderButton = (
  summaryReducer: any,
  isCustomPanel: boolean,
  login?: string
) => {
  const {
    deliveryMethod,
    newClientDetails: { willingToRegister },
    regulationsCatering,
    regulationsDietly,
    selectedProfileAddress,
  } = summaryReducer || {};

  if (login) {
    if (deliveryMethod === DeliveryMethodEnum.E) {
      return regulationsCatering && selectedProfileAddress !== 0;
    }
    return regulationsCatering;
  }

  if (!willingToRegister || isCustomPanel) {
    return regulationsCatering;
  }

  return regulationsDietly && regulationsCatering;
};

export const getProfileAddressesCitiesIds = profileDetails => {
  const { profileAddresses } = profileDetails || {};

  if (!profileAddresses) {
    return [];
  }

  return customMap('cityId')(profileAddresses)?.join(',') ?? [];
};

export const parseAddress = address => {
  const { apartmentNumber, houseNumber, street, supportedCity } = address;

  const apartment = apartmentNumber ? `m. ${apartmentNumber}` : '';
  return `${street} ${houseNumber} ${apartment}, ${supportedCity?.name}`;
};

export const handleNewAddressObject = (
  summaryReducer,
  deliveryMethod,
  profileAddressId
) => {
  const {
    methodOfPurchase,
    newAddressDetails: {
      apartmentNumber,
      buildingNumber,
      city: { cityId } = {},
      deliveryHour,
      floor,
      gate,
      gateCode,
      note,
      street,
      zipCode: { zipCodeId } = {},
    },
  } = summaryReducer || {};

  if (methodOfPurchase === 'login' && deliveryMethod !== DeliveryMethodEnum.P) {
    return null;
  }

  if (deliveryMethod === DeliveryMethodEnum.P && profileAddressId) {
    return null;
  }

  return {
    billingAddress: false,
    deliverySpot: 'DOOR',
    street,
    houseNumber: buildingNumber,
    apartmentNumber,
    gateKey: gateCode,
    floor,
    staircase: gate,
    hourPreference: deliveryHour,
    info: note,
    cityId,
    zipCodeId,
  };
};

export const handlePlacePanelOrder: AnyAction<() => void> =
  (sendDataToGTM, navigate, isPricingEnabled) => (dispatch, getState) => {
    const loyaltyPointsForRegistration =
      getLoyaltyPointsForRegistration(getState()) || {};
    const summaryReducer = getSummaryReducer(getState()) || {};
    const basketReducer = getBasketReducer(getState()) || {};
    const profileDetails = getProfileDetails(getState()) || {};
    const additionalFees = getAdditionalFees(getState()) || {};
    const finalAmountToPayAfterDiscountsAndDeliveryFee =
      getFinalSumAfterDiscountAndDeliveryFee(getState()) || {};
    const { file, hasFile } = getPdfFile(getState()) || {};
    const config = getServerConfig(getState()) || {};

    const {
      deliveryMethod,
      marketingCatering,
      marketingDietly,
      methodOfPurchase,
      newAddressDetails: { city, deliveryHour, note } = {},
      newClientDetails: {
        company,
        companyApartmentNumber,
        companyBuildingNumber,
        companyCity,
        companyName,
        companyStreet,
        companyZipCode,
        email,
        name,
        password,
        phone: phoneNumberWithoutPrefix,
        phoneNumberPrefix,
        surname,
        taxId,
        willingToRegister,
      } = {},
      originId,
      paymentType,
      pickupPointId,
      selectedProfileAddress,
    } = summaryReducer;

    const phone = `${phoneNumberPrefix}${phoneNumberWithoutPrefix}`;

    const { selectedFees } = additionalFees;

    const {
      basket,
      loyaltyPoints: { usedLoyaltyPoints } = {},
      promoCode: { code } = {},
    } = basketReducer || {};

    const {
      analytics: { googleTagManager },
      companyId,
      enhancedEcommerce,
      pdfUpload,
      youLead: { isYouLeadEnabled },
    } = config;

    const { allowMessages, firstName, lastName } = profileDetails || {};

    const newProfile = {
      firstName: name,
      lastName: surname,
      email,
      phoneNumber: phone,
      company,
      companyName: companyName,
      taxId,
    };

    const simpleOrders = generateSimpleOrders(
      {
        deliveryMethod,
        pickupPointId,
        methodOfPurchase,
        selectedProfileAddress,
        deliveryHour,
        company,
        note,
        paymentType,
      },
      basket
    );

    generateSelectedFees(selectedFees, simpleOrders);

    const invoiceData = company
      ? {
          companyName,
          taxId: taxId,
          cityName: companyCity,
          zipCode: companyZipCode,
          street: companyStreet,
          apartmentNumber: companyApartmentNumber,
          houseNumber: companyBuildingNumber,
        }
      : null;

    const newProfileAddress: NewProfileAddressT | null = handleNewAddressObject(
      summaryReducer,
      deliveryMethod,
      selectedProfileAddress?.profileAddressId
    );

    let order = {
      allowCateringMessages: marketingCatering,
      lang: 'pl',
      paymentRedirectUrl: {
        defaultUrl: `${window.location.href.split('#')[0]}#/status_platnosci`,
        failureUrl: `${window.location.href.split('#')[0]}#/wystapil_problem`,
        successUrl: `${window.location.href.split('#')[0]}#/zaplacono`,
      },
      promoCode: code ? code.code : '',
      newProfileAddress,
      simpleOrders,
      invoiceData,
      calculation: dispatch(generateCalculation()),
    };

    if (methodOfPurchase === 'guest' || methodOfPurchase === 'register') {
      order = {
        ...order,
        originId: originId !== 0 ? originId : null,
        newProfile,
        signUp: !!(methodOfPurchase === 'register' || willingToRegister),
        allowDietlyMessages: marketingDietly,
      };
    }

    // add condition that profile exists
    if (methodOfPurchase === 'login' && firstName) {
      if (!allowMessages) {
        order = {
          ...order,
          allowDietlyMessages: marketingDietly,
        };
      }
      order = {
        ...order,
        loyaltyProgramPoints: usedLoyaltyPoints,
      };
    }

    if (methodOfPurchase === 'register' || willingToRegister) {
      if (enhancedEcommerce && googleTagManager) {
        sendDataToGTM({
          event: 'GAEvent',
          eventCategory: 'Login',
          eventAction: 'Login success',
          eventLabel: 'N/A',
        });
      }

      order = {
        ...order,
        newPassword: password,
        allowDietlyMessages: marketingDietly,
      };
    }

    const { orderId } = basket[0];

    sessionStorage.removeItem('order-form');
    sessionStorage.removeItem('loyaltyProgramPoints');

    const successPageData = {
      methodOfPurchase,
      name: name ? name : firstName,
      surname,
      email,
      phone,
      companyName,
      taxId,
      orderId,
      willingToRegister,
      companyId,
      company,
      loyaltyPointsForRegistration,
      paymentType,
      marketingDietly,
    };
    const successPageDataStringified = JSON.stringify(successPageData);
    sessionStorage.setItem(
      'success-page-data-form',
      successPageDataStringified
    );

    const sendGTMTransactionEvents = async (
      orderIds,
      previousOrdersNumber,
      clientId,
      shoppingCartId = '',
      clientLifecycleState,
      email
    ) => {
      const hashedEmail = await hashString(email);

      if (googleTagManager) {
        enhancedEcommerce
          ? sendDataToGTM({
              event: 'transaction',
              ...handleEnhancedEcommerceData(
                basket,
                firstName,
                finalAmountToPayAfterDiscountsAndDeliveryFee,
                paymentType,
                city,
                code,
                orderIds,
                previousOrdersNumber,
                clientId,
                companyId,
                shoppingCartId,
                clientLifecycleState,
                hashedEmail
              ),
            })
          : sendDataToGTM({
              event: 'transaction',
              ...handleEcommerceData(
                basket,
                finalAmountToPayAfterDiscountsAndDeliveryFee,
                city
              ),
            });
      }
    };

    if (isYouLeadEnabled) {
      const ylData = (window.ylData = window.ylData || []);

      ylData.push(
        handleYouLeadPurchase(
          basket,
          selectedFees,
          code,
          city?.sectorId,
          firstName ? firstName : name,
          lastName ? lastName : surname
        )
      );
    }

    if (methodOfPurchase === 'login') {
      if (pdfUpload && hasFile) {
        dispatch(
          placeLoggedInOrderPdf(order, file, navigate, sendGTMTransactionEvents)
        );
        return;
      }

      if (isPricingEnabled) {
        dispatch(profileOrder(order, navigate, sendGTMTransactionEvents));
        return;
      }

      dispatch(placeLoggedInOrder(order, navigate, sendGTMTransactionEvents));
      return;
    }

    if (pdfUpload && hasFile) {
      dispatch(
        placeOpenOrderPdf(order, file, navigate, sendGTMTransactionEvents)
      );
      return;
    }

    if (isPricingEnabled) {
      dispatch(guestOrder(order, navigate, sendGTMTransactionEvents));
      return;
    }

    dispatch(placeOpenOrder(order, navigate, sendGTMTransactionEvents));
    return;
  };

export const redirectToLoginPage = async (
  summaryReducer,
  basketReducer,
  isThirdCookiesEnabled,
  config,
  selectedCity
) => {
  const { companyId, isCustomPanel, panelUrl, thirdPartyCookies } =
    config || {};

  const { cityId, name, sectorId } = selectedCity || {};
  const { additionalFees, basket, promoCode } = basketReducer;

  const stringifiedBasket = JSON.stringify({
    basket,
  });

  const stringifiedSummary = JSON.stringify(summaryReducer);

  sessionStorage.setItem('basket-form', stringifiedBasket);
  sessionStorage.setItem('summary-form', stringifiedSummary);

  if (thirdPartyCookies && (isSafari || isFirefox || isThirdCookiesEnabled)) {
    const mapSideOrders = sideOrders =>
      sideOrders.reduce((acc, curr) => {
        const { amount, possibleSideOrderId } = curr;

        if (amount && amount > 0) {
          acc[possibleSideOrderId] = {
            pSOId: possibleSideOrderId,
            m: amount,
          };
        }
        return acc;
      }, {});

    const mapMeals = meals =>
      Object.values(meals || {}).map(
        ({ dietCaloriesMealId, list, mealId, selected }) => {
          const findSelectedMeal = list.find(item => item.selected);
          return {
            iDCMId: dietCaloriesMealId,
            dCMId: findSelectedMeal.dietCaloriesMealId,
            dOId: findSelectedMeal.dietOptionId,
            mId: mealId,
            s: selected,
            c: findSelectedMeal.calories,
          };
        }
      );

    const dataToPanel = basket.map(
      ({
        days,
        mealExchange: { days: mealExchangeDays },
        saturdays,
        selectedCalories: { dietCaloriesId },
        selectedDays,
        selectedDiet: { dietId },
        selectedMeals,
        selectedOption: { dietOptionId },
        selectedProgram,
        selectedSideOrders,
        sets,
        sundays,
        testOrder,
      }) => {
        return {
          c: selectedDays,
          daA: days,
          sdId: dietId,
          sdcId: dietCaloriesId,
          sdoId: dietOptionId,
          diA: sets,
          m: selectedMeals.reduce((acc, curr) => {
            acc[curr.mealId] = curr.selected;
            return acc;
          }, {}),
          mC: Object.keys(mealExchangeDays || {}).reduce((acc, curr) => {
            acc[curr] = {
              m: mapMeals(mealExchangeDays[curr].mealsList),
              sO: mapSideOrders(mealExchangeDays[curr].sideOrders),
            };

            return acc;
          }, {}),
          sP: selectedProgram,
          sO: mapSideOrders(selectedSideOrders),
          tS: testOrder,
          sa: saturdays,
          su: sundays,
        };
      }
    );

    const mapDietCaloriesIds = () => {
      const array = [];
      dataToPanel.forEach(({ mC }) => {
        Object.values(mC).forEach(({ m }) => {
          m.forEach(({ dCMId, iDCMId }) => {
            array.push(dCMId, iDCMId);
          });
        });
      });

      return [...new Set(array)].join(',');
    };

    const dataToPanelToUrl = JSON.stringify({
      cityId,
      sectorId,
      name,
      diets: dataToPanel,
      dietCaloriesMealIds: mapDietCaloriesIds(),
    });

    const compressData = await compressToURL(dataToPanelToUrl);

    const promoCodeToUrl = JSON.stringify(promoCode.code.code || '');

    const selectedFeesToUrl = JSON.stringify(
      additionalFees.selectedFees.map(item => ({
        amount: item.amount,
        possibleSideOrderId: item.possibleSideOrderId,
      }))
    );

    const params = `dataFromForm=true&company=${companyId}&basket=${compressData}&selectedFees=${selectedFeesToUrl}&promoCode=${promoCodeToUrl}&redirectUrl=${window.location.href}`;

    if (isCustomPanel) {
      return window.open(`${panelUrl}/logowanie?${params}`, '_self');
    }

    return window.open(`${panelUrl}/logowanie-catering?${params}`, '_self');
  }

  if (isCustomPanel) {
    return window.open(
      `${panelUrl}/logowanie?redirectUrl=${window.location.href}`,
      '_self'
    );
  }

  return window.open(
    `${panelUrl}/logowanie-catering?redirectUrl=${window.location.href}`,
    '_self'
  );
};

export const savePromoCodeInTheLocalStorage = promoCode => {
  if (!promoCode.code) {
    return;
  }
  return localStorage.setItem(
    'basket-promo-code-form',
    JSON.stringify(promoCode)
  );
};

export const checkIfContinueParam = () => {
  const href = window.location.href;
  const params = href.split('?')[1];
  if (params && params !== '') {
    const paramsObject = params.split('&').reduce((res, item) => {
      const parts = item.split('=');
      res[parts[0]] = parts[1];
      return res;
    }, {});

    return paramsObject.continue;
  }
  return false;
};

export const retrieveDataIfContinueParam = () => (dispatch: Dispatch) => {
  if (checkIfContinueParam()) {
    const promoCode = localStorage.getItem('basket-promo-code-form');
    const parsedPromoCode = promoCode && JSON.parse(promoCode);

    if (parsedPromoCode && parsedPromoCode.code) {
      Promise.resolve(dispatch(storePromoCode(parsedPromoCode.code))).then(() =>
        localStorage.removeItem('basket-promo-code-form')
      );
    }
  }
};

export const parseDeliveryTime = deliveryTime => {
  const sliceValue = value => value?.slice(0, 5);
  const copyDeliveryTime = [...deliveryTime];

  if (copyDeliveryTime?.length) {
    copyDeliveryTime.unshift({
      name: 'Nie wybrano',
      value: 'empty',
    });
  }

  return copyDeliveryTime
    .sort((a, b) => parseFloat(a.timeTo) - parseFloat(b.timeTo))
    .map(item => {
      const { timeFrom, timeTo, value } = item;

      if (value !== 'empty') {
        if (timeFrom === '23:59:59') {
          return {
            name: `do ${sliceValue(timeTo)}`,
          };
        }

        if (timeFrom === timeTo) {
          return {
            name: `${sliceValue(timeTo)}`,
          };
        }

        return {
          name: timeFrom
            ? `od ${sliceValue(timeFrom)} do ${sliceValue(timeTo)}`
            : `do ${sliceValue(timeFrom)}`,
        };
      }

      return item;
    });
};

export const filterBasket = (
  cityItem: any,
  dispatch: any,
  basket: any,
  navigate: any,
  logged: any,
  address?: any
) => {
  const filteredBasket = basket.filter(
    item => item.selectedProgram !== 'menuConfiguration'
  );
  if (filteredBasket.length) {
    localStorage.setItem('diet-basket-form', JSON.stringify(filteredBasket));
    dispatch(storeBasket(filteredBasket));
  } else {
    clearBasketLocalStorage();
    dispatch(resetBasket());
  }
  setSelectedCityInStorage(cityItem, basket);
  dispatch(selectCityOrZipcode(cityItem, 'city'));
  dispatch(chooseExistingAddress(logged && address ? address : 0));
  dispatch(resetPreviouslySelectedDietDetails());
  dispatch(mealExchangeSelectProgram(''));
  window.scrollTo(0, 0);
  navigate('/', { replace: true });
};

export const handleThirdStepChangeCity =
  (
    cityItem: any,
    setSelectedValue?: any,
    selectedValue?: any,
    basket?: any,
    navigate?: any,
    logged = false
  ) =>
  dispatch => {
    setSelectedValue(cityItem);
    if (!selectedValue) {
      dispatch(mealExchangeChangeEditModalClickedArea('thirdStepChangeCity'));
    } else {
      filterBasket(cityItem, dispatch, basket, navigate, logged);
    }
  };
